import { createContext, useContext } from "react";
import TestStore from "./test-store";

const store = {
    testStore: new TestStore(),
};

export const StoreContext = createContext(store);

export const useStore = () => {
  return useContext<typeof store>(StoreContext);
};

export default store;
